import React, { useState } from "react";
import { Box, Typography, Grid, FormControl, InputLabel, Input, Button, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import SearchSelect from "../components/searchAndSelect"
import {postCA} from '../services/httpCalls'
import useNotify from "../utils/useNotify"
import { cleanObject } from "../utils/onboarding/clean-object";

export default function AddCA() {
    const [caForm, setCaForm] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        registrationNumber: '',
        caFirmId: '',
        caStatus: 'ACTIVE',
        role: 'USER',
    })
    let notify = useNotify()
    const selectSearchData = (e) => {
        setCaForm({...caForm, caFirmId: e.id})
    }

    const submitCa = async(e) => {
        e.preventDefault()
        let cleanCaForm = cleanObject(caForm)
        await postCA(caForm)
        .then(() => {
            notify.success("Successfully added new charted accountant")
            setCaForm({
                name: '',
                email: '',
                phoneNumber: '',
                registrationNumber: '',
                caFirmId: '',
                caStatus: 'ACTIVE',
                role: 'USER',
            })
        })
        .catch(() => {
            notify.error("Not able to add new charted accountant")
        })
    }

    return (
        <Box sx={{ padding: "1rem" }}>
            <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>Create Charted Accountant</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Box component="form" validate onSubmit={(e) => submitCa(e)}>
                        <SearchSelect selectSearchData={selectSearchData} label={"Select CA Firm"} name={"caAssignedName"} />
                        <FormControl required variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="name">Name</InputLabel>
                            <Input id="name" sx={{ width: "100%" }}
                                required={true}
                                value={caForm.name}
                                onChange={(e) =>
                                    setCaForm({
                                        ...caForm,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                        <FormControl required variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input id="email" type="email" sx={{ width: "100%" }}
                                required={true}
                                value={caForm.email}
                                onChange={(e) =>
                                    setCaForm({
                                        ...caForm,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                        <FormControl variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="phoneNumber">Phone Number</InputLabel>
                            <Input id="phoneNumber" type="number" sx={{ width: "100%" }}
                                value={caForm.phoneNumber}
                                onChange={(e) =>
                                    setCaForm({
                                        ...caForm,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                                inputProps={{ maxLength:10, min:0, minLength:10 }}
                            />
                        </FormControl>
                        <FormControl variant="standard" sx={{ width: "300px", display: "block", marginTop: ".5rem" }}>
                            <InputLabel htmlFor="registrationNumber">Registration Number</InputLabel>
                            <Input id="registrationNumber" type="number" sx={{ width: "100%" }}
                                value={caForm.registrationNumber}
                                onChange={(e) =>
                                    setCaForm({
                                        ...caForm,
                                        [e.target.id]: e.target.value,
                                    })
                                }
                                inputProps={{
                                    maxLength:100,
                                    min:0
                                }}
                            />
                        </FormControl>
                        <FormControl sx={{ paddingTop: "1rem" }}>
                            <FormLabel id="role" sx={{ fontSize: "12px" }}>Role</FormLabel>
                            <RadioGroup
                                id="role"
                                aria-labelledby="role"
                                sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                                required={true}
                                value={caForm.role}
                                onChange={(e) =>
                                    setCaForm({
                                        ...caForm,
                                        ["role"]: e.target.value,
                                    })
                                }
                            >
                                <FormControlLabel
                                    value={"USER"} control={<Radio />} label="User" />
                                <FormControlLabel
                                    value={"ADMIN"} control={<Radio />} label="Admin" />
                            </RadioGroup>
                        </FormControl>
                        <Box>
                            <Button type="submit" variant={"contained"} sx={{ mt: "2rem", }}>Add Charted Accountant</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}